namespace Areas.Inspections {
    "use strict";

    export function goBack() {
        window.history.back();
    }

    export function inspectionSelectionChanged(e: any) {
        var inspectionsSelected = e.selectedRowKeys.length > 0;

        if (inspectionsSelected) {
            enableButton("ReportButton");
        }
        else {
            disableButton("ReportButton");
        }
    }

    export function gotoCreateFromForm() {
        var keyId: any = $('#InspectionsForm').dxForm('instance').option('ProjectId');
        if (keyId != null) {
            var linkInfo = "/Inspections/Create/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoEditFromForm() {
        var keyId: any = $('#InspectionsForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/Inspections/Edit/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }




    export function gotoAssignFromForm() {
        var keyId: any = $('#InspectionsForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/Inspections/Assign/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoWriteUpFromForm() {
        var keyId: any = $('#InspectionsForm').dxForm('instance').option('KeyId');
        if (keyId != null) {
            var linkInfo = "/Inspections/WriteUp/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }

    export function gotoInspectionListFromForm() {
        var keyId: any = $('#InspectionsForm').dxForm('instance').option('ProjectId');
        if (keyId != null) {
            var linkInfo = "/Inspections/List/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Record not selected!", "warning", 2000);
        }
    }


    export function gotoProjectView() {
        var keyId: any = $('#ProjectViewButton').dxButton('instance').option('ProjectId');
        if (keyId != null) {
            var linkInfo = "/Projects/View/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Cannot find default Inspection Project ID. Contact I.S.", "warning", 2000);
        }
    }

    export function gotoCreate() {
        var keyId: any = $('#CreateInspectionButton').dxButton('instance').option('ProjectId');
        if (keyId != null) {
            var linkInfo = "/Inspections/Create/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Cannot find default Inspection Project ID. Contact I.S.", "warning", 2000);
        }
    }

    export function gotoCreateInspection() { 
        var keyId: any = $('#CreateInspectionButton').dxButton('instance').option('ProjectId');
        if (keyId != null) {
            var linkInfo = "/Inspections/Create/Index/" + keyId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("Cannot find default Inspection Project ID. Contact I.S.", "warning", 2000);
        }

      
    }

    export function gotoCreateReinspection(inspectionId: number, projectId: number) {

            var linkInfo = "/Inspections/Create/Reinspection/" + inspectionId.toString() + "";
            location.href = linkInfo;

    }



    export function gotoWriteUp() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Inspections/WriteUp/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoDeputy() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Inspections/Deputy/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoAssign() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Inspections/Assign/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoEdit() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            const selectedRows: any = dataGrid.getSelectedRowsData()[0];
            var inspectionNbr = selectedRows.inspectionNumber;
            if (inspectionNbr.indexOf("r") > -1) {
                var linkInfo = "/Inspections/Edit/ReInspection/" + dataId.toString() + "";
            } else {
                var linkInfo = "/Inspections/Edit/Index/" + dataId.toString() + "";
            }    

            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoInspectorEdit() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Inspections/InspectorEdit/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function gotoBulkReInspection() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');

        var ids = {
            inspectionIds: dataGrid.getSelectedRowKeys(),
            inspectionProjectId: dataGrid.option("InspectionProjectId")
        };

        if (ids != null) {
            sendRequest("/Inspections/Create/BulkReInspection", JSON.stringify(ids), "POST");
        }
    }   


    export function gotoView() {
        var dataGrid = $('#InspectionGrid').dxDataGrid('instance');
        var dataId = dataGrid.getSelectedRowKeys()[0];
        if (dataId != null) {
            var linkInfo = "/Inspections/View/Index/" + dataId.toString() + "";
            location.href = linkInfo;
        }
        else {
            DevExpress.ui.notify("You need to select a row first!", "warning", 2000);
        }
    }

    export function viewLink(cellElement, cellInfo) {
        var fieldData = cellInfo.data.inspectionId;
        var statusData = cellInfo.data.statusLk;
        var inspectionNumber = cellInfo.data.inspectionNumber;
        var projectId = cellInfo.component.option("InspectionProjectId");
        var linkInfo = "";
        var viewName = "Index"; 


        if (inspectionNumber.indexOf("r") > -1) {
            viewName = "ReInspection";
        }
        
        if (statusData == "Rejected") {
            linkInfo = "<a href= '/Inspections/View/Index/" + String(fieldData) + "'>View</a> <br/><br/>" +
                "<a href= '#' onClick='Areas.Inspections.gotoCreateReinspection(" + String(fieldData) + ", " + projectId + ")'>ReInspection</a> <br/>";
            $(cellElement).css('background-color', 'orange');
        }
        else if (statusData == "Draft" || statusData == "Returned") {
            if (viewName == "Index") {
                linkInfo = "<a href= '/Inspections/Edit/Index/" + String(fieldData) + "'>Edit</a>";
                
            } else {
                linkInfo = "<a href= '/Inspections/Edit/ReInspection/" + String(fieldData) + "'>Edit</a>";
            }

        }
        else {
            if (viewName == "Index") {
                linkInfo = "<a href= '/Inspections/View/Index/" + String(fieldData) + "'>View</a>";
            } else {
                linkInfo = "<a href= '/Inspections/View/ReInspection/" + String(fieldData) + "'>View</a>";
            }
        }
        cellElement.html(linkInfo);
    }

    export function createReinspection(inspectionId: number, projectId: number) {
        sendRequest(`/Inspections/Create/ReInspection/${inspectionId}/${projectId}/`, "", "POST");
    }

    export function gotoProjectList() {
        var linkInfo = "/Projects/List/Active";
        location.href = linkInfo;
    }

    export function highLightTextUser() {
        Areas.highLightTextBase("#inspectionhtmleditoruser");
    }

    export function highLightTextDeputy() {
        Areas.highLightTextBase("#inspectionhtmleditordeputy");
    }

    export function highLightTextInspector() {
        Areas.highLightTextBase("#inspectionhtmleditorinspector");
    }

}



